import {useEffect, useRef} from 'react';

/**
 * @param {number} count
 * @param {function} emptySoundNotification
 * @returns {{soundPlayer: *}}
 */
export default function usePlaySoundClient({count, emptySoundNotification}) {
  const soundPlayer = useRef(null);

  useEffect(() => {
    if (!count) return;
    soundPlayer.current?.play().catch(e => console.log(e));
    emptySoundNotification();
  }, [count]);

  return {soundPlayer};
}
